import React, { useState } from "react";
import CreateTaskForm from "../../components/CreateTaskForm";

export default function CreateTaskPage() {
  const [success, setSuccess] = useState(false);

  if (success) {
    return (
      <div className="fade-in">
        <div className="page-header"><h1>➕ Create Task</h1></div>
        <div className="card" style={{ padding: 40, textAlign: "center" }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
          <h2 style={{ color: "var(--success)", marginBottom: 8 }}>Task Created Successfully!</h2>
          <p style={{ color: "var(--gray-500)", marginBottom: 24 }}>The task has been added to the Admin table and will sync to User Tasks automatically.</p>
          <button className="btn btn-primary" onClick={() => setSuccess(false)}>➕ Create Another Task</button>
        </div>
      </div>
    );
  }

  return (
    <div className="fade-in">
      <div className="page-header">
        <h1>➕ Create Task</h1>
        <p>Fill in the form below to assign a new task. It will be added to the Admin table.</p>
      </div>
      <div className="card" style={{ overflow: "visible" }}>
        <div className="card-header">
          <span className="card-title">Task Details</span>
        </div>
        <div className="card-body">
          <CreateTaskForm onSuccess={() => setSuccess(true)} onClose={() => {}} />
        </div>
      </div>
    </div>
  );
}
